import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Images
import BG from '../../images/sign/imagen-terramar-login.jpg';
import LOGO from '../../images/sign/logo.png';

// Components
import LoginForm from '../LoginForm';
import LanguageSelect from '../LanguageSelect';
import ForgotPassword from '../ForgotPassword';
import AcceptCookies from '../AcceptCookies';

// Styles
import styles from './index.module.sass';

export default function Sign({
  device,
  history,
  basename,
  webservice,
  screenSize,
  getCookie,
  country,
}) {
  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <div className={styles.left}>
        <div className={styles.loginHeader}>
          <div className={styles.languageSelect}>
            <LanguageSelect />
          </div>
          <img src={LOGO} alt='Terramar Logo' className={styles.logo} />
        </div>

        <Switch>
          <Route
            path='/forgotPassword'
            render={(props) => {
              return (
                <ForgotPassword
                  screenSize={screenSize}
                  history={history}
                  basename={basename}
                  webservice={webservice}
                  getCookie={getCookie}
                />
              );
            }}
          />
          <Route
            path='/'
            render={(props) => {
              return (
                <LoginForm
                  screenSize={screenSize}
                  history={history}
                  basename={basename}
                  webservice={webservice}
                  country={country}
                />
              );
            }}
          />
        </Switch>
      </div>
      {screenSize === 'desktop' && (
        <div
          className={styles.right}
          style={{
            backgroundImage: `url(${BG})`,
          }}
        />
      )}
      <AcceptCookies screenSize={screenSize} />
    </div>
  );
}
